import {useTranslation} from "react-i18next";
import React from "react";

const ReadinessScoreBlock = ({ percent, title, description }: { percent?: string; title?: string; description?: string }) => {
    const { t } = useTranslation();
    const percentNum = Number(percent) || 0;
    return (
        <div className="readiness-score-block">
            <div className="readiness-score-title">{t('subscription.readinessScore')}</div>
            <div className="readiness-score-card">
                <svg className="readiness-score-circle" width="90" height="90" viewBox="0 0 90 90">
                    <circle cx="45" cy="45" r="38" stroke="#e5e7eb" strokeWidth="8" fill="none" />
                    <circle
                        cx="45" cy="45" r="38"
                        stroke="#4f6ef7"
                        strokeWidth="8"
                        fill="none"
                        strokeDasharray={2 * Math.PI * 38}
                        strokeDashoffset={2 * Math.PI * 38 * (1 - percentNum / 100)}
                        strokeLinecap="round"
                        style={{transition: 'stroke-dashoffset 0.6s'}} />
                    <text x="50%" y="60%" textAnchor="middle" fontSize="1.6rem" fontWeight="bold" fill="#4f6ef7">{percentNum}%</text>
                </svg>
                <div>
                    <div className="readiness-score-main">{title || t('subscription.yourScore')}</div>
                    <div className="readiness-score-sub">{description || t('subscription.closerThanThink')}</div>
                </div>
            </div>
            <div className="comparison-disclaimer">{t('subscription.aheadOfBeginners')}</div>
        </div>
    );
};

export default ReadinessScoreBlock;
